































import { Component, Vue } from 'vue-property-decorator';
import firebase from 'firebase/app';
import * as firebaseui from 'firebaseui';
import { firebaseAuth } from '../../server/init';

@Component({
  components: {},
})
export default class Login extends Vue {
  private email: string | null = null;
  private password: string | null = null;
  private loginError: string | null = null;
  private emailError: string | null = null;
  private investorSignup: boolean = false;
  private resetSubmitted: boolean = false;

  public created() {
    if (this.$route.query.redirect) {
      this.investorSignup = true;
    }
  }



  private login() {
    if (this.email && this.password) {
      firebaseAuth.signInWithEmailAndPassword(this.email, this.password)
      .then((cred) => {
        this.loginError = null;
        if (this.$route.query.redirect) {
          console.log('redirect', this.$route.query.redirect);
          this.$router.push('/business-plan');
          this.investorSignup = true;
        } else {
          this.$router.push('/');
        }
      }).catch((err) => {
        this.loginError = err.message;
      });
    } else {
      this.loginError = 'Please enter email and password.';
    }
  }

  private sendPasswordRequest() {
    if (this.email) {
      firebaseAuth.sendPasswordResetEmail(this.email)
      .then(function() {
        console.log('email sent');
      })
      .catch(function(error) {
        console.log('Log in error', error);
      });
      this.emailError = null;
      this.loginError = null;
      this.resetSubmitted = true;
    } else {
      this.emailError = 'Please enter the email you used to signup.';
      this.resetSubmitted = false;
    }
  }
}
